import Vue from 'vue'
import Router from 'vue-router'
import consultaWeb from './views/consultaWeb.vue'
import descargaWeb from './views/descargaWeb.vue'

Vue.use(Router);

export default new Router({
  mode: "history",
  routes: [
    {
      path: '/',
      name: 'consultaWeb',
      component: consultaWeb
    },
    {
      path: '/s/:uid',
      name: 'descarga-web',
      component: descargaWeb
    }
  ]
})
